import { render, staticRenderFns } from "./AutoForm.vue?vue&type=template&id=3f6d4cfa&scoped=true"
import script from "./AutoForm.vue?vue&type=script&lang=js"
export * from "./AutoForm.vue?vue&type=script&lang=js"
import style0 from "./AutoForm.vue?vue&type=style&index=0&id=3f6d4cfa&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6d4cfa",
  null
  
)

export default component.exports